module.exports = __webpack_public_path__ + "static/media/clubParadaOnline.6d2fd99a.svg";